import { Col, Row } from "react-bootstrap";

import Gmail from "../../assets/images/auth/gmail.svg";
import Microsoft from "../../assets/images/auth/microsoft.png";
import { useSocialAuth } from "./hooks/useSocialAuth";

const SocialAuth = ({ isSignin }) => {
  const { microsoft365Connect, googleConnect } = useSocialAuth();

  return (
    <Row className="m-0">
      <Col
        className="social-btn cursor-pointer d-flex align-items-center justify-content-center justify-content-sm-start heading14px fw-semibold mr-4"
        onClick={() => googleConnect(isSignin)}
      >
        <img
          src={Gmail}
          alt="Gmail"
          width="20"
          height="20"
          className="mr-sm-2"
        />{" "}
        <span className="d-none d-sm-block">Gmail</span>
      </Col>
      <Col
        className="social-btn d-flex cursor-pointer align-items-center justify-content-center justify-content-sm-start heading14px fw-semibold"
        onClick={() => microsoft365Connect(isSignin)}
      >
        <img
          src={Microsoft}
          height="20"
          width="20"
          alt="LinkedIn"
          className="mr-sm-2 bg-white"
        />{" "}
        <span className="d-none d-sm-block">Microsoft 365</span>
      </Col>
    </Row>
  );
};

export default SocialAuth;
